import { BranchIdsController } from './branchIds.controller';
import template from './branchIds.html';

export const createRequestBranchIdsComponent = {
  name: 'createRequestBranchIds',
  restrict: 'E',
  template,
  controller: BranchIdsController,
  controllerAs: 'vm',
  bindings: {
    descriptionTitle: '@',
    descriptionText: '@',
    branchIds: '<',
    model: '=',
    form: '=',
  },
};
